import { TiceService } from '../views/jumprope-intelligent/services/tice'
import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../views/jumprope-intelligent/Index.vue')
const Result = () => import('../views/jumprope-intelligent/Result.vue')
const Workbench = () => import('../views/jumprope-intelligent/Workbench.vue')
const StudentList = () => import('../views/jumprope-intelligent/StudentList.vue')
const DeviceStatus = () => import('../views/jumprope-intelligent/DeviceStatus.vue')
const InClassQuiz = () => import('../views/jumprope-intelligent/InClassQuiz.vue')

const Game = () => import('../views/jumprope-intelligent/Game.vue')

const SupplyIndex = () => import('../views/jumprope-intelligent/supply/index.vue')
const SupplyMatch = () => import('../views/jumprope-intelligent/supply/match.vue')
const DrillSocket = () => import('../views/jumprope-intelligent/DrillSocketTestPage.vue')

export const indexRoute: RouteConfig = {
  path: '/jumprope-intelligent',
  name: 'jumprope_intelligent',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '智能跳绳',
  },
}

export const resultRoute: RouteConfig = {
  path: '/jumprope-intelligent/result',
  name: 'jumprope-intelligent_result',
  component: Result,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '测试结果',
  },
}

export const workbenchRoute: RouteConfig = {
  path: '/jumprope-intelligent/workbench',
  name: 'jumprope_intelligent_workbench',
  component: Workbench,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '跳绳测试',
  },
}

export const studentListRoute: RouteConfig = {
  path: '/jumprope-intelligent/student-list',
  name: 'jumprope_intelligent_student_list',
  component: StudentList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '测试名单',
  },
}

export const deviceStatusRoute: RouteConfig = {
  path: '/jumprope-intelligent/device-status',
  name: 'jumprope_intelligent_device_status',
  component: DeviceStatus,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '调试设备情况',
  },
}

export const inClassQuizRoute: RouteConfig = {
  path: '/jumprope-intelligent/in-class-quiz',
  name: 'jumprope_intelligent_in_class_quiz',
  component: InClassQuiz,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '随堂测验',
  },
}

export const gameRoute: RouteConfig = {
  path: '/jumprope-intelligent/game',
  name: 'jumprope_intelligent_game',
  component: Game,
  props: (route) => ({
    ...route.query,
    ...route.params,
    setting: JSON.parse(route.query.setting as string),
  }),
  meta: {
    title: '多人跳绳比赛',
    ignoreLogin: true, // 临时调试用，不需要登录
  },
}

// =========== 供应链发货检验流程 ============
export const supplyIndexRoute: RouteConfig = {
  path: '/jumprope-intelligent/supply/index',
  name: 'jumprope_intelligent_supply_index',
  component: SupplyIndex,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '发货检验-V2',
    ignoreLogin: true,
  },
}
export const supplyMatchRoute: RouteConfig = {
  path: '/jumprope-intelligent/supply/match',
  name: 'jumprope_intelligent_supply_match',
  component: SupplyMatch,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '发货检验-V2',
    ignoreLogin: true,
  },
}

//测试drill socket
export const drillSocketRoute: RouteConfig = {
  path: '/jumprope-intelligent/drill-socket',
  name: 'jumprope_intelligent_drill_socket',
  component: DrillSocket,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '跳绳比赛',
  },
}

export default [
  indexRoute,
  resultRoute,
  workbenchRoute,
  studentListRoute,
  deviceStatusRoute,
  inClassQuizRoute,
  gameRoute,

  supplyIndexRoute,
  supplyMatchRoute,
  drillSocketRoute,
]

export function navigateToJumpropeIntelligent(router: VueRouter) {
  router.push({ name: indexRoute.name })
}

export function navigateToJumpropeIntelligentResult(router: VueRouter) {
  router.push({ name: resultRoute.name })
}

export function navigateToJumpropeIntelligentWorkbench(router: VueRouter) {
  TiceService.clearCurrentData()
  router.push({ name: workbenchRoute.name })
}

export function redirectToJumpropeIntelligentWorkbench(router: VueRouter) {
  router.replace({ name: workbenchRoute.name })
}

export function navigateToJumpropeIntelligentStudentList(router: VueRouter) {
  router.push({ name: studentListRoute.name })
}

export function redirectToJumpropeIntelligentStudentList(router: VueRouter) {
  router.replace({ name: studentListRoute.name })
}

export function navigateToJumpropeIntelligentDeviceStatus(router: VueRouter) {
  router.push({ name: deviceStatusRoute.name })
}

export function navigateToJumpropeIntelligentInClassQuiz(router: VueRouter) {
  router.push({ name: inClassQuizRoute.name })
}
